import { Button, Form, Input, Radio, Modal } from "antd";
import React, { useState } from "react";
import rules from "@/config/rules";
import "../../index.less";

/**
 * 企业发票表单组件
 * @returns
 */
const EnterpriseInvoice = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const onsubmit = (params) => {
    console.log("params", params);
    setIsModalVisible(true);
  };
  return (
    <>
      <div className="enterprise-invoice-page small">
        <h4 className="fw-bold mb-4">填写发票信息</h4>
        <p>
          *电子发票与纸质发票具有同等法律效力，可支持报销入账；同时根据增值税管理办法要求，如需为企业开具增值税发票，需提供纳税人识别号或统一社会信用代码，否则该发票无法作为税收凭证。
        </p>
        <Form
          name="wrap"
          labelCol={{ flex: "108px" }}
          wrapperCol={{ span: 8 }}
          labelAlign="right"
          // initialValues={{ remember: true }}
          onFinish={(params) => onsubmit(params)}
          autoComplete="off"
          className="pt-4"
        >
          <Form.Item label="发票金额:">
            <span className="desc">100元</span>
          </Form.Item>
          <Form.Item label="发票类型:">
            <span className="desc">增值税电子普通发票</span>
          </Form.Item>
          <Form.Item label="抬头类型:" name="type">
            <Radio.Group defaultValue={2}>
              <Radio value={1}> 个人 </Radio>
              <Radio value={2}> 企业 </Radio>
            </Radio.Group>
          </Form.Item>
          <Form.Item
            label="发票抬头:"
            name="invoice_looked_up"
            className="require_item"
            rules={[{ required: true, message: "请输入您的发票抬头" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item label="发票内容:">
            <span className="desc">软件名</span>
          </Form.Item>
          {/* 如果当前是企业发票则显示，个人发票则不现实纳税人识别号 */}
          <Form.Item
            label="纳税人识别号:"
            name="invoice"
            className="require_item"
            rules={[{ required: true, message: "请输入您的纳税人识别号" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="手机号码:"
            name="phone"
            className="require_item"
            rules={[
              { required: true, message: "请输入您的手机号码" },
              {
                pattern: new RegExp(rules.phone),
                message: "手机号格式不正确，请重新输入!",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="收票邮箱:"
            name="email"
            className="require_item"
            rules={[
              { required: true, message: "请输入您的收票邮箱" },
              {
                pattern: new RegExp(rules.email),
                message: "邮箱格式不正确,请重新输入!",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item align="center" className="text-center pt-3">
            <Button
              type="primary"
              htmlType="submit"
              className="submit-invoice fs-5 fw-bold"
            >
              确定开票
            </Button>
          </Form.Item>
        </Form>
      </div>

      <Modal
        title=""
        visible={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        maskClosable={false}
        footer={false}
        width={640}
      >
        <div
          className="text-center"
          style={{ fontSize: "1rem", padding: "40px" }}
        >
          <img
            src="https://images.niuxuezhang.cn/imgs/account-center/success-icon.svg"
            alt=""
          />
          <div className="fw-bold mt-4 pt-3 mb-2">申请成功 !</div>
          <p>发票将在24小时内完成，请在收票邮件或个人中心-订单信息查询.</p>
        </div>
      </Modal>
    </>
  );
};

export default EnterpriseInvoice;
